// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___Loader__spinner___rypFU > div {
  width: 1em;
  height: 1em;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: src-styles-components-___Loader__sk-bouncedelay___djXWg 1.4s infinite ease-in-out both;
  animation: src-styles-components-___Loader__sk-bouncedelay___djXWg 1.4s infinite ease-in-out both;
}
.src-styles-components-___Loader__spinner___rypFU .src-styles-components-___Loader__bounce1___rmcA6 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.src-styles-components-___Loader__spinner___rypFU .src-styles-components-___Loader__bounce2___GbLZk {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@-webkit-keyframes src-styles-components-___Loader__sk-bouncedelay___djXWg {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes src-styles-components-___Loader__sk-bouncedelay___djXWg {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/Loader.less"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,WAAA;EACA,oCAAA;EAEA,mBAAA;EACA,qBAAA;EACA,yGAAA;EACA,iGAAA;AAAF;AAGA;EACE,+BAAA;EACA,uBAAA;AADF;AAIA;EACE,+BAAA;EACA,uBAAA;AAFF;AAKA;EACE;;;IAAgB,2BAAA;EAAhB;EACA;IAAM,2BAAA;EAEN;AACF;AAAA;EACE;;;IACE,2BAAA;IACA,mBAAA;EAIF;EAHE;IACA,2BAAA;IACA,mBAAA;EAKF;AACF","sourcesContent":[".spinner > div {\n  width: 1em;\n  height: 1em;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  } 40% {\n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var spinner = `src-styles-components-___Loader__spinner___rypFU`;
var _1 = `src-styles-components-___Loader__sk-bouncedelay___djXWg`;
export { _1 as "sk-bouncedelay" };
export var bounce1 = `src-styles-components-___Loader__bounce1___rmcA6`;
export var bounce2 = `src-styles-components-___Loader__bounce2___GbLZk`;
export default ___CSS_LOADER_EXPORT___;
